import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './Skeleton.scss';

function SkeletonText ({
	header, lines, marginBottom, width
}) {

	const className = classNames('Skeleton', 'Skeleton--text', header && 'Skeleton--header');

	/*
		Values arranged for header + text pairs so that 1 line
		headers do not have the same length as the first line
		of a following text placeholder
	*/
	const lineWidthVariation = [ '95%', '92.5%', '95%', '90%' ];
	const lineWidthVariationLength = lineWidthVariation.length;
	const lastLineWidth = '75%';

	const a = Array(lines).fill(1);
	const text = a.map((i, key) => {

		const offset = header ? key : key + 1;
		let styleWidth = width || lineWidthVariation[offset % lineWidthVariationLength];

		// Shorten the last line in a series of lines
		if (!width && lines > 1 && key === lines - 1) {

			styleWidth = lastLineWidth;

		}
		// eslint-disable-next-line react/no-array-index-key
		return <div key={key} className={className} style={{ marginBottom, width: styleWidth }} />;

	});

	return (
		<>
			{text}
		</>
	);

}

SkeletonText.defaultProps = {
	header: false,
	lines: 1,
	marginBottom: undefined,
	width: undefined
};

SkeletonText.propTypes = {
	header: PropTypes.bool,
	lines: PropTypes.number,
	marginBottom: PropTypes.string,
	width: PropTypes.string
};

export default SkeletonText;
